var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTfvc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_tfs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.175,18.342a8.171,8.171,0,1,1,8.171-8.171A8.181,8.181,0,0,1,10.175,18.342Zm0-11.673a3.5,3.5,0,1,0,3.5,3.5A3.506,3.506,0,0,0,10.175,6.669Z",
    style: {
      fill: "#68217a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.089,24.023a4.2,4.2,0,1,1-1.231-2.971A4.189,4.189,0,0,1,28.089,24.023Z",
    style: {
      fill: "#68217a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,6.21a4.2,4.2,0,1,1-1.231-2.971A4.189,4.189,0,0,1,30,6.21Z",
    style: {
      fill: "#68217a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.416,25.8a4.2,4.2,0,1,1-1.231-2.971A4.189,4.189,0,0,1,10.416,25.8Z",
    style: {
      fill: "#68217a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.758,
    y: 6.37,
    width: 8.189,
    height: 2.801,
    transform: "translate(-1.301 5.119) rotate(-14.233)",
    style: {
      fill: "#68217a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.834,
    y: 18.591,
    width: 7.601,
    height: 2.802,
    transform: "translate(-13.621 22.479) rotate(-75.774)",
    style: {
      fill: "#68217a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.171,
    y: 14.085,
    width: 2.801,
    height: 9.292,
    transform: "translate(-7.805 18.485) rotate(-44.709)",
    style: {
      fill: "#68217a"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTfvc);
export default __webpack_public_path__ + "static/media/tfvc.a1c78bbff2ecd592e91ea7a3af413f22.svg";
export { ForwardRef as ReactComponent };